import { TOOL_CALL_INDICATOR_NODE_TITLE_CLASS } from "../../../../ToolCallIndicator.constants";

export interface ToolCallIndicatorNodeNameLabelProps {
  name: string;
}

export default function ToolCallIndicatorNodeNameLabel({
  name,
}: ToolCallIndicatorNodeNameLabelProps) {
  return <span className={TOOL_CALL_INDICATOR_NODE_TITLE_CLASS}>{name}()</span>;
}
